import apiClient from "./api";

export interface User {
  id?: number;
  warehouse_id?: number;
  warehouse_code?: string;
  warehouse_name?: string;
  branch_id?: number;
  branch_code?: string;
  branch_name?: string;
  role_permission_id?: number;
  biller_id?: number;
  biller_code?: string;
  biller_name?: string;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  phone?: string;
  address?: string;
  password?: string;
  password_confirmation?: string;
  salt?: string;
  pin_code?: string;
  last_ip_address?: string;
  ip_address?: string;
  remember_code?: string;
  last_login?: string;
  active?: number; // 1 for active, 0 for inactive
  status?: "active" | "inactive"; // Keeping this for UI compatibility if needed
  gender?: number; // Changed from string to number for backend compatibility
  view_right?: number;
  edit_right?: number;
  company?: string;
  avatar?: string;
  deleted_at?: string;
  deleted_by?: number;
  status_deleted?: number;
  created_by?: number;
  updated_by?: number;
  created_at?: string;
  updated_at?: string;
}
const userService = {
  async getUsers(params?: any): Promise<User[]> {
    const response = await apiClient.get("/users", { params });
    return response.data.data ?? response.data;
  },

  async getUser(id: number): Promise<User> {
    const response = await apiClient.get(`/users/userdetail/${id}`);
    const data = response.data.data ?? response.data;
    return Array.isArray(data) ? data[0] : data;
  },

  async getCurrentProfile(): Promise<User> {
    const response = await apiClient.get("/users/profile");
    return response.data.data ?? response.data;
  },

  async createUser(input: User | FormData): Promise<User> {
    const response = await apiClient.post("/users", input, input instanceof FormData
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : undefined);
    return response.data.data ?? response.data;
  },

  async updateUser(id: number, input: Partial<User> | FormData): Promise<User> {
    if (input instanceof FormData) {
      input.append("_method", "PUT");
      const response = await apiClient.post(`/users/${id}`, input, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data ?? response.data;
    }

    const response = await apiClient.put(`/users/${id}`, input);
    return response.data.data ?? response.data;
  },

  async updateCurrentProfile(id: number, input: Partial<User> | FormData): Promise<User> {
    if (input instanceof FormData) {
      input.append("_method", "PUT");
      const response = await apiClient.post(`/users/update-profile/${id}`, input, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data.data ?? response.data;
    }

    const response = await apiClient.put(`/users/update-profile/${id}`, input);
    return response.data.data ?? response.data;
  },

  async changeCurrentPassword(
    id: number,
    input: { current_password: string; new_password: string; new_password_confirmation: string }
  ): Promise<{ message: string }> {
    const response = await apiClient.put(`/users/change-password/${id}`, {
      current_password: input.current_password,
      new_password: input.new_password,
      new_password_confirmation: input.new_password_confirmation,
    });
    return response.data;
  },

  async deleteUser(id: number): Promise<void> {
    await apiClient.delete(`/users/${id}`);
  },
};

export default userService;
